// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }



// 获取收藏列表
export function userFavoritesList(token,data) {
  return request({
    url: "/api/user_favorites/index",
    method: "post",
    data,
    headers:{
      token,
      // "Content-Type":"multipart/form-data"
     },
    
  });
}

// 获取收藏类型列表
export function typeList(token) {
  return request({
    url: "/api/user_favorites/type_list",
    method: "get",
    headers:{ token }
  });
}


// 获取加入收藏
export function addFavoritesList(token,data) {
  return request({
    url: "/api/user_favorites/add",
    method: "post",
    data,
    headers:{
      token,
      // "Content-Type":"multipart/form-data"
     },
    
  });
}

// 取消收藏
export function delFavoritesList(token,data) {
  return request({
    url: "/api/user_favorites/del",
    method: "post",
    data,
    headers:{
      token,
      // "Content-Type":"multipart/form-data"
     },
    
  });
}